/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Settings_Template_Topic_MoveInputs */



/**
* | output |
* | --- |
* | "Move topic {position}" |
*
* @param {Settings_Template_Topic_MoveInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topic_move = /** @type {((inputs: Settings_Template_Topic_MoveInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topic_MoveInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Verplaats onderwerp ${i?.position}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Déplacer le sujet ${i?.position}`)
	return /** @type {LocalizedString} */ (`Move topic ${i?.position}`)
});